const ORDER_OF_PLAY = 'orderofplay';
const MATCH_SHEET = 'matchsheet';

export const UNPUBLISHED_DRAWS_SCHEDULE_WARNING =
    'Note: Some matches on this day\'s schedule are from unpublished draws and won\'t appear on the event page until those draws are published.';

export default {
    ORDER_OF_PLAY,
    MATCH_SHEET,
};
